import styled from 'styled-components'

export const StyledCard = styled.a<{ hasChild: boolean }>`
  display: flex;
  flex-wrap: wrap;
  border-radius: ${props => props.theme.radius.normal};
  padding: ${props => props.theme.spacing.medium};
  background-color: ${props => props.theme.colors.white[500]};
  padding-bottom: ${props => (props.hasChild ? props.theme.spacing.medium : 0)};
  text-align: left;
  transition: all ease-in-out 0.16s;
  cursor: pointer;

  b {
    font-weight: ${props => props.theme.fontWeight.medium};
  }

  &:hover {
    box-shadow: 0 6px 10px 0 rgb(0 0 0 / 4%);
    transform: scale(1.02);
  }
`

export const Header = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: ${props => props.theme.spacing.xlarge};

  img {
    width: 2rem;
    height: auto;
  }
`

export const Date = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;

  @media screen and (max-width: ${a => a.theme.screens.tablet}) {
    b {
      margin-left: ${props => props.theme.spacing.default};
    }
  }
`

export const InfosWrapper = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: ${props => props.theme.spacing.xlarge};
  margin-top: ${props => props.theme.spacing.medium};
`

export const Details = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
  margin-top: ${props => props.theme.spacing.medium};
`

export const PlateLabel = styled.div`
  height: fit-content;
  background-color: ${props => props.theme.colors.black[200]};
  border-radius: ${props => props.theme.radius.normal};
  margin-bottom: ${props => props.theme.spacing.default};
  padding: ${props => props.theme.spacing.default};
  font-weight: ${props => props.theme.fontWeight.medium};
`
